import type {
  ProjectionRelationshipDataType,
  Status
} from '@library/types/projection';

export interface RankDrawerProjectionsRequest {
  fromDate: string;
  leagueId: Array<string>;
  statTypeId: ProjectionRelationshipDataType['id'];
  statuses?: Array<Status>;
  gameIds?: Array<string>;
  teamIds?: Array<string>;
}

export enum RankMode {
  STARTING = 'starting',
  COPIED = 'copied'
}
